module.exports = __webpack_public_path__ + "static/media/5_of_hearts.faef658b.png";